<template>
  <vx-card style="padding-left: 10px">
    <div class="relative" style="height: 39px">
      <vs-button
        class="lg:absolute right-0"
        @click="createFranchiseHandler"
        icon-pack="feather"
        icon="icon-edit"
        >Create Admin</vs-button
      >
    </div>

    <div id="data-list-list-view" class="data-list-container">
      <div class="lg:hidden mt-2">
        <div class="mb-2 pr-2 flex flex-no-wrap">
          <div class="w-full pr-1">
            <vs-input
              icon="search"
              style="width: 100%"
              placeholder="Search"
              v-model="searchInputString"
            />
          </div>
          <div class="w-24 pl-1">
            <vs-select
              style="width: 100%"
              placeholder="10"
              vs-multiple
              v-model="dataTableParams.limit"
              class="mr-6"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in limitOptions"
                :clearable="false"
              />
            </vs-select>
          </div>
        </div>
        <ul>
          <li :key="indextr" v-for="(tr, indextr) in users">
            <div class="rounded mb-2 p-2" style="border: 1px solid #e8e8e8">
              <div class="flex">
                <h4 class="mr-2 mobile-text">
                  {{
                    users[indextr].firstName
                      ? users[indextr].firstName
                      : "N/A" | capitalize
                  }}
                </h4>
                <h4 class="mobile-text">
                  {{
                    users[indextr].lastName
                      ? users[indextr].lastName
                      : "N/A" | capitalize
                  }}
                </h4>
              </div>
              <div>
                <p class="mobile-text">
                  {{ users[indextr].email || "N/A" }}
                </p>
              </div>
              <div class="flex">
                <vx-tooltip text="Edit Admin Detail">
                  <vs-button
                    style="float: left"
                    type="border"
                    size="small"
                    @click="editDetailHandler(users[indextr]._id)"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="m-1"
                  ></vs-button>
                </vx-tooltip>

                <vx-tooltip
                  style="float: left"
                  text="View Admin Detail"
                  position="top"
                >
                  <vs-button
                    style="float: left"
                    type="border"
                    size="small"
                    @click="viewDetailHandler(users[indextr]._id)"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="m-1"
                  ></vs-button>
                </vx-tooltip>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <vs-table
        class="hidden lg:block"
        ref="table"
        :sst="true"
        :total="totalDocs"
        :data="users"
        @search="search"
        @change-page="handleChangePage"
        @sort="handleSort"
        :max-items="dataTableParams.limit"
        search
        :noDataText="noDataText"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse flex-grow justify-between"
        >
          <div style="float: left">
            <vs-select
              placeholder="10"
              vs-multiple
              v-model="dataTableParams.limit"
              class="mr-6"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in limitOptions"
                :clearable="false"
              />
            </vs-select>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="firstName">First Name</vs-th>
          <vs-th sort-key="lastName">Last Name</vs-th>
          <vs-th sort-key="email">Email</vs-th>
          <vs-th sort-key="status">Status</vs-th>
          <vs-th sort-key="createdAt">Created At</vs-th>
          <vs-th size="25%">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].firstName">{{
              data[indextr].firstName | capitalize
            }}</vs-td>
            <vs-td :data="data[indextr].firstName">{{
              data[indextr].lastName | capitalize
            }}</vs-td>
            <vs-td :data="data[indextr].email">{{ data[indextr].email }}</vs-td>
            <vs-td :data="data[indextr].status">
              <p
                v-if="data[indextr].status === 'Pending_Approval'"
                class="text-sm"
              >
                Pending Approval
              </p>
              <p v-else class="text-sm">{{ data[indextr].status }}</p>
            </vs-td>
            <vs-td :data="data[indextr].createdAt">{{
              data[indextr].createdAt | date_formatter
            }}</vs-td>
            <vs-td style="display: flex" :data="data[indextr]._id">
              <vx-tooltip text="Edit Admin Detail">
                <vs-button
                  style="float: left"
                  type="border"
                  size="small"
                  @click="editDetailHandler(data[indextr]._id)"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="m-1"
                ></vs-button>
              </vx-tooltip>

              <vx-tooltip
                style="float: left"
                text="View Admin Detail"
                position="top"
              >
                <vs-button
                  style="float: left"
                  type="border"
                  size="small"
                  @click="viewDetailHandler(data[indextr]._id)"
                  icon-pack="feather"
                  icon="icon-eye"
                  class="m-1"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="m-2">
        <span class="mr-2">
          {{
            dataTableParams.page * dataTableParams.limit -
            (dataTableParams.limit - 1)
          }}
          -
          {{
            totalDocs - dataTableParams.page * dataTableParams.limit > 0
              ? dataTableParams.page * dataTableParams.limit
              : totalDocs
          }}
          of {{ totalDocs }}
        </span>
        <div class="pagination-div" v-if="serverResponded">
          <paginate
            :page-count="totalPage"
            :click-handler="handleChangePage"
            class="pagination"
            :page-range="9"
            :prevText="'<'"
            :nextText="'>'"
          ></paginate>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  components: {},
  data() {
    return {
      noDataText: 'Loading...',
      isMounted: false,
      totalDocs: 0,
      currentPage: 1,
      searchInputString: null,
      dataTableParams: {
        search: '',
        sort: 'createdAt',
        dir: 'desc',
        page: 1,
        limit: 25,
      },
      serverResponded: false,
      users: [],
      date: new Date(),
      limitOptions: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
      ],
      awaitingSearch: null,
    };
  },
  methods: {
    ...mapActions('franchise', ['fetchFranchiseAdmin']),
    search(searching) {
      this.searchInputString = searching;
    },
    getFranchiseAdminList() {
      let self = this;
      this.fetchFranchiseAdmin(self.dataTableParams)
        .then((res) => {
          const data = res.data.data[0];
          self.users = data.docs;
          self.totalDocs = data.pagination[0].total;
          self.page = data.pagination[0].page;
          self.serverResponded = true;
          self.noDataText = 'No Admin Available';
        })
        .catch(() => {
          self.noDataText = 'No Admin Available';
        });
    },
    handleSearch(searching) {
      if (this.awaitingSearch) {
        clearTimeout(this.awaitingSearch);
        this.awaitingSearch = null;
      }
      this.awaitingSearch = setTimeout(() => {
        this.serverResponded = false;
        this.dataTableParams.search = searching;
        this.dataTableParams.page = 1;
        this.$refs.table.currentx = 1;
        this.getFranchiseAdminList();
      }, 500);
    },
    handleChangePage(page) {
      this.dataTableParams.page = page;
      this.getFranchiseAdminList();
    },
    handleSort(key, active) {
      this.serverResponded = false;
      this.dataTableParams.sort = key;
      this.dataTableParams.dir = active;
      this.dataTableParams.page = 1;
      this.$refs.table.currentx = 1;
      this.getFranchiseAdminList();
    },
    editDetailHandler(id) {
      this.$router.push({
        name: 'FranchiseAdminEdit',
        params: { franchiseId: id },
      });
    },
    viewDetailHandler(id) {
      this.$router.push({
        name: 'FranchiseAdminView',
        params: { franchiseId: id },
      });
    },
    createFranchiseHandler() {
      this.$router.push({ name: 'SubFranchiseCreate' });
    },
  },
  watch: {
    searchInputString: function (newVal) {
      this.handleSearch(newVal);
    },
    'dataTableParams.page': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dataTableParams.page = newVal;
        this.getFranchiseAdminList();
      }
    },
    'dataTableParams.limit': function (newlimit, oldLimit) {
      if (newlimit !== oldLimit) {
        this.serverResponded = false;
        this.dataTableParams.page = 1;
        this.dataTableParams.limit = newlimit;
        this.getFranchiseAdminList();
      }
    },
  },
  computed: {
    totalPage: function () {
      return this.totalDocs / this.dataTableParams.limit >
        parseInt(this.totalDocs / this.dataTableParams.limit)
        ? parseInt(this.totalDocs / this.dataTableParams.limit) + 1
        : parseInt(this.totalDocs / this.dataTableParams.limit);
    },
  },
  created() {
    this.getFranchiseAdminList();
  },
};
</script>

<style scoped>
.mobile-text {
  color: #164d3d;
}
</style>
